import { lazy } from "react";

export const About = lazy(() => import("../container/About/About"));
export const Footer = lazy(() => import("../container/Footer/Footer"));
export const Header = lazy(() => import("../container/Header/Header"));
export const Testimonial = lazy(() => import("../container/Testimonial/Testimonial"));
export const Work = lazy(() => import("../container/Work/Work"));
export const Skills = lazy(() => import("../container/Skills/Skills"));

